var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"arrow-svg",class:{ rotated: _vm.rotated },attrs:{"width":"12","height":"8","viewBox":"0 0 12 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M2 2L6 6L10 2","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"square"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }